import useApi from "@/hooks/api/useApi";
import useWeb3UserAddress from "@/hooks/web3/useWeb3UserAddress";
import { HeroStats } from "@/types";

/**
 * Hook to fetch exploration dashboard data for a user
 * @package api:go
 * @link https://api.superform.xyz/superrewards/exploration/{user}
 */
export default function useHeroStats() {
  const user = useWeb3UserAddress();
  const { data, isLoading, isError, error, mutate } = useApi<HeroStats, HeroStats>(
    {
      path: `/superrewards/exploration/${user}/`,
      api: "v2",
    },
    {
      enabled: Boolean(user),
      strategy: "cached",
    }
  );

  return {
    data,
    isLoading,
    isError,
    error,
    refresh: () => mutate(),
  };
}
